import { gql } from '@provision/graphql-client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import { WORKFLOW_FIELDS, WORKFLOW_VERSION_FIELDS } from './workflow.fragments';

export const GET_WORKFLOWS_QUERY = gql`
  query GetWorkflows($params: QueryParams, $skipTotalRecords: Boolean = false)
  @entity(name: "Workflow") {
    getWorkflow(queryParams: $params) {
      records {
        ...WorkflowFields
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${WORKFLOW_FIELDS}
  ${META_DATA_QUERY_FIELDS}
`;

export const GET_WORKFLOW_VERSIONS_QUERY = gql`
  query GetWorkflowVersions($params: QueryParams, $skipTotalRecords: Boolean = false)
  @entity(name: "WorkflowVersion") {
    getWorkflowVersion(queryParams: $params) {
      records {
        ...WorkflowVersionFields
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${WORKFLOW_VERSION_FIELDS}
  ${META_DATA_QUERY_FIELDS}
`;
